import normalizeUrl from "src/features/HomepageCarouselBanners/utils/normalizeUrl";

const adaptEditFullpageTakeoverForm = (
	id: number,
	data: BannerFormState
): CarouselBanner => {
	const result = {
		id,
		variant: "standard",
		template: data.bannerType,
		banner_type: "internal" as "internal" | "sponsored",
		button_style: data.steps[3].fields![0].givenAnswer as BannerVariant,
		button_text: data.steps[3].fields![1].givenAnswer,
		button_visible: data.steps[3].isStepDisabled ? false : true,
		name: data.steps[0].fields![0].givenAnswer,
		image_portrait_uuid:
			data.steps[1].fields && data.steps[1].fields[0].givenAnswer
				? data.steps[1].fields[0].givenAnswer
				: null,
		image_landscape_uuid:
			data.steps[2].fields && data.steps[2].fields[0].givenAnswer
				? data.steps[2].fields[0].givenAnswer
				: null,
		published: false,
		// Link comes from the flat LinkPicker fields, not the step-array — this
		// mirrors adaptCreateBanner. The previous version read the (unused)
		// step-3 button-URL field, so every edit silently dropped the link.
		button_link: normalizeUrl(data.buttonLink)
	} as CarouselBanner;

	// Always send open_in_browser on edit: the PUT only applies it when present,
	// so omitting it would preserve a stale value (e.g. switching External ->
	// In-app). Matches adaptEditBanner.
	result.open_in_browser = data.openInBrowser ?? false;

	// Hashtag link: send feed_id and clear the URL fields (matches create).
	if (data.linkFeedId) {
		result.feed_id = data.linkFeedId;
		result.button_link = "";
		result.open_in_browser = false;
	}

	return result;
};

export default adaptEditFullpageTakeoverForm;
